export default "__VITE_ASSET__56bc82fb__"